import { render } from "./privacy.vue?vue&type=template&id=4fea1b76&ts=true"
import script from "./privacy.vue?vue&type=script&lang=ts"
export * from "./privacy.vue?vue&type=script&lang=ts"

import "./privacy.vue?vue&type=style&index=0&id=4fea1b76&lang=less"

import exportComponent from "/Users/shinet/Documents/shinet_h5/g1-privacy-pro/privacy2H5Source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__